// resetPasswordForm.js
import { rerenderValidationNew, validateField } from "../utils/validation";

// Constants
const RESET_PASSWORD_FORM_SELECTOR = "#reset-password-form";

/**
 * Initializes reset password form validation.
 */
export function initResetPasswordFormValidation() {
    const form = document.querySelector(RESET_PASSWORD_FORM_SELECTOR);
    if (!form) return;

    form.addEventListener("input", handleFormInput);
    form.addEventListener("change", handleFormInput);
}

/**
 * Validates fields on input or change events.
 *
 * @param {Event} e
 */
function handleFormInput(e) {
    const inputEl = e.target;
    const fieldName = inputEl.name;

    const allErrors = validateField(e.currentTarget, inputEl, getResetPasswordValidationRules(), getWhitelistResetPassword());
    const fieldErrors = allErrors?.[fieldName] || [];
    rerenderValidationNew(inputEl, fieldErrors);
}

/**
 * Defines validation rules for the reset password form.
 *
 * @returns {Object}
 */
export function getResetPasswordValidationRules() {
    return {
        email: {
            presence: true,
            email: true
        }
    };
}

/**
 * Defines the whitelist of fields to validate.
 *
 * @returns {Object}
 */
export function getWhitelistResetPassword() {
    return {
        email: true
    };
}
